<template>
  <div>
    <div v-if="user.firstname" class="display-3 font-weight-bold pb-2">
      {{ user.firstname }} {{ user.middlename }}
    </div>
    <div
      v-if="!user.firstname && user.lastname"
      class="display-3 font-weight-bold pb-2"
    >
      {{ user.lastname }}
    </div>
    <div class="font-weight-medium pb-1">{{ emails_for_letters }}</div>
    <div class="font-weight-medium pb-2">{{ user.sms_to_phone | phone }}</div>
    <div class="subtitle-2 font-weight-medium text--secondary pb-2">
      Изменить личные данные и пароль можно в офисе компании
    </div>

    <!-- todo Настройки уведомлений -->
    <hr v-if="false" class="my-4" />

    <div v-if="false" class="display-1 font-weight-bold pt-2 pb-4">
      Настройки уведомлений
    </div>

    <v-layout v-if="false" align-center justify-space-between class="pb-2">
      <label for="notification" class="font-weight-medium">
        Получать уведомления по почте
      </label>
      <div>
        <v-switch id="notification" class="mt-0" hide-details> </v-switch>
      </div>
    </v-layout>

    <hr class="my-4" />

    <div class="link font-weight-medium">
      <icon-profile class="mr-2"></icon-profile>
      <a
        href="https://stat.profintel.ru"
        class="link valign-middle"
        target="_blank"
      >
        Перейти в личный кабинет ИНСИС
      </a>
    </div>
    <div class="subtitle-2 font-weight-bold pl-4 pt-3">
      В личном кабинете вы сможете скачать счета и акты (выполненных работ) или
      заказать акт сверки
    </div>
  </div>
</template>

<script>
import IconProfile from "../icon/IconProfile.vue";

export default {
  name: "UserProfile",

  components: {
    IconProfile
  },

  computed: {
    user() {
      return this.$store.getters.user;
    },
    emails_for_letters() {
      return this.user.emails_for_letters.map(item => item.email).join(",");
    }
  },

  filters: {
    // todo фильтр для красивого отображения телефона
    phone: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  }
};
</script>
